
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.1014 6.4711C8.88641 5.87974 10.7739 5.25445 13.1046 6.03139C16.136 7.04188 20.3437 3 20.3437 3C20.3437 3 23.2093 10.5785 16.965 12.0941C14.4027 12.7161 13.7594 13.553 13.2699 14.1898C12.8772 14.7007 12.5834 15.0829 11.4773 15.1222L15.0653 19.6969C15.4615 20.202 15.2859 20.9442 14.7055 21.2183L14.4205 21.3529C13.9984 21.5522 13.4947 21.433 13.2066 21.0658L3.77349 9.03852C3.37734 8.53343 3.55289 7.79122 4.13333 7.51713L5.1398 7.04185L5.13982 7.04187C5.79118 6.90516 6.43924 6.69046 7.1014 6.4711Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowinstructionsFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
